import {Text} from '@rdcomponents/text/text';
import {Button, Popover} from 'antd';

import {Locale} from '../../../../../../../provider/locale/locale';

import yandexGoodPlaceBadge from './images/yandex-good-place-badge.png';
import {getYandexSpravAwardsLink} from './yandex-good-place-mark-helper';
import * as styles from './yandex-good-place-mark.scss';

type PropsType = {
    yandexGoodPlace?: unknown;
};

export function YandexGoodPlaceMark(props: PropsType): JSX.Element | null {
    const {yandexGoodPlace} = props;

    // eslint-disable-next-line no-undefined
    if (yandexGoodPlace === null || yandexGoodPlace === undefined) {
        return null;
    }

    return (
        <Popover
            className={styles.YandexGoodPlaceMark_popoverContent}
            content={
                <div className={styles.YandexGoodPlaceMark_popoverContent}>
                    <Text block stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_GOOD_PLACE_CONTENT" />
                    <Button
                        className={styles.YandexGoodPlaceMark_popoverLink}
                        href={getYandexSpravAwardsLink()}
                        target="_blank"
                        type="link"
                    >
                        <Locale stringKey="TEXT__MORE_DETAILS" />
                    </Button>
                </div>
            }
            title={
                <Text
                    block
                    bolder
                    className={styles.YandexGoodPlaceMark_popoverTitle}
                    stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__YANDEX_GOOD_PLACE_TITLE"
                />
            }
        >
            <div className={styles.YandexGoodPlaceMark}>
                <img alt="" role="presentation" src={yandexGoodPlaceBadge} />
            </div>
        </Popover>
    );
}
